<template>
    <div class="speed-data-section">
        <!-- 模块标题 -->
        <h3>3.3、发动机负荷率</h3>

        <!-- ECharts 柱状图容器 -->
        <div>
            <el-row :gutter="20">
                <!-- 第一个饼图：工作/非工作区域 -->
                <el-col :span="12">
                    <el-card shadow="hover">
                        <div class="chart-container" ref="workChart"></div>
                    </el-card>
                </el-col>
                <!-- 第二个饼图：经济/非经济区 -->
                <el-col :span="12">
                    <el-card shadow="hover">
                        <div class="chart-container" ref="ecoChart"></div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <div class="table-caption">图表3</div>
        <div class="note">
            <p>说明：</p>
            <p>非工作区表示发动机怠速、零负荷的工作范围，该区域中发动机不处于驱动车辆的状态。</p>
        </div>
        <!-- 横向多列表格（完全匹配截图） -->
        <div class="table-wrapper">
            <el-table
      :data="tableData"
      border
      :cell-style="cellStyle"
      :header-cell-style="headerCellStyle"
      style="width: max-content; min-width: 100%;"
    >
      <!-- 转速列（首列） -->
      <el-table-column
        label="转速(r/min)"
        prop="speed"
       
        align="center"
      />
      <!-- 扭矩列（横向表头） -->
      <el-table-column
        v-for="(torque, idx) in torqueHeaders"
        :key="idx"
        :label="torque"
        align="center"
        width="50"
      >
        <template slot-scope="scope">
          {{ scope.row[`torque${torque.replace(/[≤>]/g, '')}`] || '0.00' }}
        </template>
      </el-table-column>
      <!-- 累计列 -->
      <el-table-column
        label="累计"
        prop="total"
        width="80"
        align="center"
      />
    </el-table>
        </div>
        <div class="table-caption">数据表3</div>

        <!-- 说明文本 -->
        <div class="note">
            <p>说明：</p>
            <p>发动机工作在经济转速范围内中等负荷工况下经济性较好，因此发动机工况分布在该区域内的比例越大、越集中车辆的燃耗经济性越好。</p>
        </div>
    </div>
</template>

<script>

export default {
    name: "barchart",

    data() {
        return {

          // 扭矩表头（横向列）
      torqueHeaders: [
        '>95', '≤95', '≤90', '≤80', '≤70', '≤60', 
        '≤50', '≤40', '≤30', '≤20', '≤10'
      ],
      // 表格数据：转速作为行，扭矩作为列
      tableData: [
        { speed: '≤700', torque50: '0.12', torque40: '0.24', torque30: '0.79', torque20: '5.44', torque10: '33.06', total: '39.70' },
        { speed: '≤800', torque60: '0.10', torque50: '0.14', torque40: '0.29', torque30: '0.67', torque20: '5.55', torque10: '5.81', total: '12.57' },
        { speed: '≤900', torque90: '0.02', torque70: '0.05', torque60: '0.14', torque50: '0.19', torque40: '0.30', torque30: '0.45', torque20: '0.68', torque10: '0.94', total: '2.76' },
        { speed: '≤1000', torque90: '0.15', torque80: '0.05', torque70: '0.24', torque60: '0.28', torque50: '0.30', torque40: '0.33', torque30: '0.42', torque20: '0.69', torque10: '1.14', total: '3.45' },
        { speed: '≤1100', torque90: '0.07', torque80: '0.19', torque70: '0.35', torque60: '0.46', torque50: '0.48', torque40: '0.56', torque30: '0.59', torque20: '0.78', torque10: '1.43', total: '4.86' },
        { speed: '≤1200', torque90: '0.03', torque80: '0.45', torque70: '0.41', torque60: '0.60', torque50: '0.66', torque40: '0.69', torque30: '0.71', torque20: '0.96', torque10: '1.89', total: '6.39' },
        { speed: '≤1300', torque90: '0.02', torque80: '0.25', torque70: '0.37', torque60: '0.49', torque50: '0.79', torque40: '1.06', torque30: '0.85', torque20: '0.87', torque10: '2.00', total: '6.83' },
        { speed: '≤1400', torque80: '0.24', torque70: '0.39', torque60: '0.39', torque50: '0.53', torque40: '0.65', torque30: '0.54', torque20: '0.65', torque10: '1.42', total: '4.87' },
        { speed: '≤1500', torque80: '0.15', torque70: '0.38', torque60: '0.58', torque50: '1.01', torque40: '1.45', torque30: '1.22', torque20: '0.88', torque10: '1.20', total: '6.91' },
        { speed: '≤1600', torque80: '0.05', torque70: '0.12', torque60: '0.31', torque50: '0.52', torque40: '1.02', torque30: '1.33', torque20: '1.14', torque10: '1.25', total: '5.76' },
        { speed: '≤1700', torque80: '0.01', torque70: '0.06', torque60: '0.14', torque50: '0.18', torque40: '0.25', torque30: '0.26', torque20: '0.27', torque10: '0.55', total: '1.74' },
        { speed: '≤1800', torque70: '0.02', torque60: '0.05', torque50: '0.05', torque40: '0.07', torque30: '0.07', torque20: '0.06', torque10: '0.16', total: '0.48' },
        { speed: '≤1900', torque60: '0.02', torque50: '0.02', torque40: '0.02', torque30: '0.04', torque20: '0.03', torque10: '0.04', total: '0.18' },
        { speed: '≤2000', torque60: '0.01', torque50: '0.02', torque40: '0.01', torque30: '0.02', torque20: '0.01', torque10: '0.02', total: '0.08' },
        { speed: '≤2200', torque40: '0.01', torque10: '0.01', total: '0.02' },
        { speed: '≤2400', total: '0.00' },
        { speed: '>2400', total: '0.00' },
        { speed: '累计', torque90: '0.30', torque80: '1.41', torque70: '2.40', torque60: '3.61', torque50: '5.02', torque40: '6.97', torque30: '7.98', torque20: '18.03', torque10: '54.28', total: '100.00' }
      ]
        };
    },
    mounted() {
        this.initWorkChart();
        this.initEcoChart();
        // 监听窗口缩放
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        // 表头样式（转速行背景色）
        headerCellStyle({ columnIndex }) {
            if (columnIndex === 0) return { 'background-color': '#f5f7fa' }; // 扭矩列表头
            return { 'background-color': '#e6f7ff' }; // 转速列表头
        },
        // 单元格样式（背景色区分）
        cellStyle({ row, columnIndex }) {
            const torque = row.torque;
            const speedColKey = this.speedHeaders[columnIndex - 1]?.replace(/[≤>]/g, '');
            const cellValue = row[`speed${speedColKey}`] || '0.00';
            const value = Number(cellValue);

            // 累计行样式
            if (torque === '累计') {
                return { 'background-color': '#f5f5f5', 'font-weight': 'bold' };
            }
            // 扭矩列样式
            if (columnIndex === 0) {
                return { 'background-color': '#f5f7fa' };
            }
            // 单元格背景色（按数值区分）
            if (value >= 10) return { 'background-color': '#fde2e2' }; // 深红色
            if (value >= 5) return { 'background-color': '#ffe6e6' }; // 浅红色
            if (value >= 1) return { 'background-color': '#e6f7ff' }; // 浅蓝色
            if (value > 0) return { 'background-color': '#f0f9eb' }; // 浅绿色
            return {};
        },
        initWorkChart() {
            const workChart = echarts.init(this.$refs.workChart);
            const option = {
                title: {
                    text: '发动机运行状态饼图',
                    left: 'center',
                    textStyle: { fontSize: 16 }
                },
                grid: {
                    left: '3%',

                    bottom: '8%',
                    right: '3%',

                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c}%'
                },
                series: [
                    {
                        type: 'pie',


                        data: [
                            { value: 48.69, name: '工作区域', itemStyle: { color: '#409EFF' } },
                            { value: 51.31, name: '非工作区域', itemStyle: { color: '#E6A23C' } }
                        ],
                        label: {
                            show: true,
                            position: 'inside',
                            formatter: '{b}: {c}%'
                        },
                        labelLine: { show: true }
                    }
                ]
            };
            workChart.setOption(option);
            this.$workChart = workChart;
        },

        // 初始化“经济/非经济区”饼图
        initEcoChart() {
            const ecoChart = echarts.init(this.$refs.ecoChart);
            const option = {
                title: {
                    text: '发动机工作状态饼图',
                    left: 'center',
                    textStyle: { fontSize: 16 }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c}%'
                },
                series: [
                    {
                        type: 'pie',

                        data: [
                            { value: 25.60, name: '经济区', itemStyle: { color: '#67C23A' } },
                            { value: 74.40, name: '非经济区', itemStyle: { color: '#F56C6C' } }
                        ],
                        label: {
                            show: true,
                            position: 'inside',
                            formatter: '{b}: {c}%'
                        },
                        labelLine: { show: true }
                    }
                ]
            };
            ecoChart.setOption(option);
            this.$ecoChart = ecoChart;
        },

        // 窗口缩放时图表自适应
        handleResize() {
            this.$workChart?.resize();
            this.$ecoChart?.resize();
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (row.isGreen) {
                return 'green-column';
            } else {
                if (columnIndex === 0) {
                    return 'cell-header';
                }
            }

        },
        // 合并单元格方法

    }
};
</script>
<style scoped>
.chart-container {
    width: 100%;
    height: 300px;
    /* 图表高度 */
}

.table-wrapper {

    overflow-x: auto;
    /* 横向滚动适配 */
}

::v-deep .el-table th,
.el-table td {
    padding: 6px 0;
    /* 减小单元格内边距，适配多列 */
    font-size: 12px;
}

::v-deep .el-table .green-cell {
    background-color: #dff0d8 !important;
    /* 浅绿色背景 */
}

::v-deep .el-table .cell {
    padding: 0px 0;
    font-size: 8pt !important;

}

::v-deep .green-column {
    background-color: #dff0d8 !important;
    /* 浅绿色背景 */
}

::v-deep .cell-header-warning {
    background: #dba8a8 !important;
    color: #000 !important;
    border-bottom: 1px solid #000 !important;
    border-right: 1px solid #000 !important;
}

::v-deep .el-table th.el-table__cell>.cell {
    padding-left: 4px !important;
    padding-right: 4px !important;
}

.table-caption {
    text-align: center;
    margin: 8px 0;
    font-weight: 500;
}
</style>